import React, { useCallback } from "react";
import Modal from "../../apps/ClassroomApp/components/Modal.jsx";
import { useWaypoint } from "../common/waypoint/WaypointProvider.jsx";
import CrmList from "./CrmList.jsx";

/* A CRM card's list, in the house dialog the classroom dashboard's tiles
   open (Modal, as StatBreakdownModal). A row opens its record in the view
   popup (Waypoint); this one closes first -- two stacked popups is never
   what is wanted, and Waypoint's own back link is not needed here. */
const CrmListModal = ({ kind, card, filters, onClose }) => {
  const { open: openEntity } = useWaypoint();

  const openFromList = useCallback(
    (type, id) => {
      onClose();
      openEntity(type, id);
    },
    [onClose, openEntity],
  );

  return (
    <Modal
      eyebrow="CRM"
      title={card.label}
      onClose={onClose}
      size="wide"
      labelledBy="crm-list-title"
      footer={
        <button type="button" className="pg-btn pg-btn--main" onClick={onClose}>
          Close
        </button>
      }
    >
      <CrmList kind={kind} card={card} filters={filters} onOpen={openFromList} />
    </Modal>
  );
};

export default CrmListModal;
